import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  alpha, AppBar, Box, Button, Collapse, Container, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText,
  Toolbar, Typography, useMediaQuery, useTheme
} from '@mui/material'
import { Close as CloseIcon, DesignServices, ExpandLess, ExpandMore, Menu as MenuIcon } from '@mui/icons-material'

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [aboutSubmenuOpen, setAboutSubmenuOpen] = useState(false)
  const [desktopAboutOpen, setDesktopAboutOpen] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const location = useLocation()

  const navItems = [
    { href: '/', label: 'Home' },
    { href: '/portfolio', label: 'Portfolio' },
    {
      href: '/about',
      label: 'About',
      subItems: [
        { href: '/about', label: 'Our Story' },
        { href: '/about/founder', label: 'The Founder' }
      ]
    },
    { href: '/services', label: 'Services' },
  ]

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
    if (mobileOpen) {
      setAboutSubmenuOpen(false)
    }
  }

  const handleAboutSubmenuToggle = () => {
    setAboutSubmenuOpen(!aboutSubmenuOpen)
  }

  const isAboutSectionActive = location.pathname.startsWith('/about')

  const drawer = (
    <Box sx={{
      pt: 3,
      px: 3,
      height: '100%',
      background: 'linear-gradient(135deg, #FDFDFB 0%, #FAF8F5 100%)'
    }}>

      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 4,
        pb: 2,
          borderBottom: `1px solid ${alpha('#675944', 0.2)}`
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500, fontFamily: '"Ballet", cursive',
              color: '#1a1a1a',
              fontSize: '1.4rem'
            }}
          >
              Imseen Interiors
          </Typography>
        </Box>
        <IconButton
          onClick={handleDrawerToggle}
          sx={{
              color: '#675944',
              '&:hover': {bgcolor: alpha('#675944', 0.1)}
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>


      <List sx={{ mb: 2 }}>
        {navItems.map(({ href, label, subItems }) => (
          <React.Fragment key={href}>
            {subItems ? (
              <>
                <ListItem disablePadding sx={{ mb: 1 }}>
                  <ListItemButton
                    onClick={handleAboutSubmenuToggle}
                    sx={{
                      borderRadius: '8px',
                      py: 1.5,
                      '&:hover': {
                          bgcolor: alpha('#675944', 0.08)
                      }
                    }}
                  >
                    <ListItemText
                      primary={label}
                      sx={{
                        '& .MuiTypography-root': {
                            color: isAboutSectionActive ? '#675944' : '#1a1a1a',
                          fontWeight: isAboutSectionActive ? 600 : 400,
                          fontSize: '1.1rem'
                        }
                      }}
                    />
                    {aboutSubmenuOpen ?
                        <ExpandLess sx={{color: '#675944'}}/> :
                      <ExpandMore sx={{ color: '#666' }} />
                    }
                  </ListItemButton>
                </ListItem>
                <Collapse in={aboutSubmenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={{ pl: 2 }}>
                    {subItems.map((subItem) => (
                      <ListItem key={subItem.href} disablePadding sx={{ mb: 0.5 }}>
                        <ListItemButton
                          component={Link}
                          to={subItem.href}
                          onClick={handleDrawerToggle}
                          selected={location.pathname === subItem.href}
                          sx={{
                            borderRadius: '6px',
                            py: 1.25,
                            '&.Mui-selected': {
                                bgcolor: alpha('#675944', 0.12),
                              '&:hover': {
                                  bgcolor: alpha('#675944', 0.15)
                              }
                            },
                            '&:hover': {
                                bgcolor: alpha('#675944', 0.08)
                            }
                          }}
                        >
                          <ListItemText
                            primary={subItem.label}
                            sx={{
                              '& .MuiTypography-root': {
                                  color: location.pathname === subItem.href ? '#675944' : '#666',
                                fontWeight: location.pathname === subItem.href ? 500 : 400,
                                fontSize: '1rem'
                              }
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </>
            ) : (
              <ListItem disablePadding sx={{ mb: 1 }}>
                <ListItemButton
                  component={Link}
                  to={href}
                  onClick={handleDrawerToggle}
                  selected={location.pathname === href}
                  sx={{
                    borderRadius: '8px',
                    py: 1.5,
                    '&.Mui-selected': {
                        bgcolor: alpha('#675944', 0.12),
                      '&:hover': {
                          bgcolor: alpha('#675944', 0.15)
                      }
                    },
                    '&:hover': {
                        bgcolor: alpha('#675944', 0.08)
                    }
                  }}
                >
                  <ListItemText
                    primary={label}
                    sx={{
                      '& .MuiTypography-root': {
                          color: location.pathname === href ? '#675944' : '#1a1a1a',
                        fontWeight: location.pathname === href ? 600 : 400,
                        fontSize: '1.1rem'
                      }
                    }}
                  />
                </ListItemButton>
              </ListItem>
            )}
          </React.Fragment>
        ))}
      </List>


        <Box sx={{p: 2, pt: 3, borderTop: `1px solid ${alpha('#675944', 0.2)}`}}>
        <Button
          component={Link}
          to="/contact"
          variant="contained"
          fullWidth
          onClick={handleDrawerToggle}
          sx={{
              bgcolor: '#675944',
            color: 'white',
            borderRadius: '25px',
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 500,
            textTransform: 'none',
            '&:hover': {
              bgcolor: '#A6895D',
              transform: 'translateY(-1px)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          Begin Your Journey
        </Button>
      </Box>
    </Box>
  )

  const DesktopAboutMenu = () => (
    <Box
      onMouseEnter={() => setDesktopAboutOpen(true)}
      onMouseLeave={() => setDesktopAboutOpen(false)}
      sx={{ position: 'relative' }}
    >
      <Button
        sx={{
          fontWeight: isAboutSectionActive ? 600 : 400,
            color: isAboutSectionActive ? '#675944' : '#1a1a1a',
          fontSize: '1rem',
          textTransform: 'none',
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -2,
            left: '50%',
            transform: 'translateX(-50%)',
            width: isAboutSectionActive ? '20px' : '0px',
            height: '2px',
              bgcolor: '#675944',
            transition: 'width 0.3s ease'
          },
          '&:hover::after': {
            width: '20px'
          }
        }}
      >
        About
      </Button>
      <Box
        sx={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          bgcolor: 'background.paper',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
          borderRadius: '12px',
          minWidth: 200,
          opacity: desktopAboutOpen ? 1 : 0,
          visibility: desktopAboutOpen ? 'visible' : 'hidden',
          transition: 'all 0.3s ease',
          zIndex: 1000,
          overflow: 'hidden',
            border: `1px solid ${alpha('#675944', 0.1)}`,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -8,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 16,
            height: 16,
            bgcolor: 'background.paper',
              borderTop: `1px solid ${alpha('#675944', 0.1)}`,
              borderLeft: `1px solid ${alpha('#675944', 0.1)}`
          }
        }}
      >
        <List dense sx={{ py: 1 }}>
          {navItems.find(item => item.href === '/about')?.subItems?.map((subItem) => (
            <ListItem key={subItem.href} disablePadding>
              <ListItemButton
                component={Link}
                to={subItem.href}
                sx={{
                  py: 1.5,
                  px: 3,
                  fontWeight: location.pathname === subItem.href ? 600 : 400,
                    color: location.pathname === subItem.href ? '#675944' : '#1a1a1a',
                  fontSize: '0.95rem',
                  '&:hover': {
                      bgcolor: alpha('#675944', 0.08)
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                {subItem.label}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  )

  return (
    <>
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                bgcolor: alpha('#FDFDFB', 0.95),
                backdropFilter: 'blur(20px)',
                borderBottom: `1px solid ${alpha('#675944', 0.1)}`,
                transition: 'all 0.3s ease',
                height: '70px',
                overflow: 'visible',
                zIndex: 3
            }}
        >
            <Container maxWidth="xl">
                <Toolbar sx={{
                    py: 0.3,
                    minHeight: '70px !important',
                    alignItems: 'center'
                }}>

                    <Box
                        component={Link}
                        to="/"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexGrow: 1,
                            textDecoration: 'none',
                            gap: 1.5
                        }}
                    >
                        <Box
                            component="img"
                            src='/images/ImseenNBGLogo.png'
                            alt='Imseen Interiors Logo'
                            loading="eager"
                            sx={{
                                width: 'auto',
                                height: {xs: '200px', sm: '250px', md: '350px'},
                                maxWidth: {xs: '120px', sm: '150px', md: '200px'},
                                objectFit: 'contain',
                                borderRadius: '60%',
                                marginTop: {xs: '-80px', sm: '-100px', md: '-150px'},
                                marginBottom: {xs: '-80px', sm: '-100px', md: '-150px'},
                                overflow: 'hidden',
                            }}
                        />
                    </Box>

                    {isMobile ? (
                        <IconButton
                            sx={{
                                color: '#675944',
                                bgcolor: alpha('#675944', 0.05),
                                border: `1px solid ${alpha('#675944', 0.2)}`,
                                '&:hover': {
                                    bgcolor: alpha('#675944', 0.1),
                                    transform: 'scale(1.05)'
                                },
                                transition: 'all 0.3s ease'
                            }}
                            onClick={handleDrawerToggle}
                        >
                            <MenuIcon/>
                        </IconButton>
                    ) : (
                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                            {navItems.map(({href, label, subItems}) => (
                                subItems ? (
                                    <DesktopAboutMenu key={href}/>
                                ) : (
                                    <Button
                                        key={href}
                                        component={Link}
                                        to={href}
                                        sx={{
                                            fontWeight: location.pathname === href ? 600 : 400,
                                            color: location.pathname === href ? '#675944' : '#1a1a1a',
                                            fontSize: '1rem',
                                            textTransform: 'none',
                                            position: 'relative',
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: -2,
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                width: location.pathname === href ? '20px' : '0px',
                                                height: '2px',
                                                bgcolor: '#675944',
                                                transition: 'width 0.3s ease'
                                            },
                                            '&:hover::after': {
                                                width: '20px'
                                            }
                                        }}
                                    >
                                        {label}
                                    </Button>
                                )
                            ))}
                            <Button
                                component={Link}
                                to="/contact"
                                variant="outlined"
                                sx={{
                                    borderColor: '#675944',
                                    background: '#A8815B',
                                    color: '#fbfafa',
                                    borderRadius: '25px',
                                    px: 4,
                                    py: 1,
                                    fontSize: '1rem',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    '&:hover': {
                                        bgcolor: alpha('#A8815B', 0.6),
                                        borderColor: '#A6895D',
                                        transform: 'translateY(-1px)'
                                    },
                                    transition: 'all 0.3s ease',
                                    ml: 1
                                }}
                            >
                                Contact
                            </Button>
                        </Box>
                    )}
                </Toolbar>
            </Container>
        </AppBar>

        <Drawer
            variant="temporary"
            anchor="right"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
                keepMounted: true,
            }}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 320,
                    boxShadow: '-20px 0 40px rgba(0, 0, 0, 0.1)',
                },
            }}
        >
            {drawer}
        </Drawer>

        <Toolbar sx={{minHeight: '70px !important'}}/>
    </>
  )
}

export default Header
